"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.color = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var COLOR_NAMES = [
    'transparent',
    'aliceblue',
    'antiquewhite',
    'aqua',
    'aquamarine',
    'azure',
    'beige',
    'bisque',
    'black',
    'blanchedalmond',
    'blue',
    'blueviolet',
    'brown',
    'burlywood',
    'cadetblue',
    'chartreuse',
    'chocolate',
    'coral',
    'cornflowerblue',
    'cornsilk',
    'crimson',
    'cyan',
    'darkblue',
    'darkcyan',
    'darkgoldenrod',
    'darkgray',
    'darkgrey',
    'darkgreen',
    'darkkhaki',
    'darkmagenta',
    'darkolivegreen',
    'darkorange',
    'darkorchid',
    'darkred',
    'darksalmon',
    'darkseagreen',
    'darkslateblue',
    'darkslategray',
    'darkslategrey',
    'darkturquoise',
    'darkviolet',
    'deeppink',
    'deepskyblue',
    'dimgray',
    'dimgrey',
    'dodgerblue',
    'firebrick',
    'floralwhite',
    'forestgreen',
    'fuchsia',
    'gainsboro',
    'ghostwhite',
    'gold',
    'goldenrod',
    'gray',
    'grey',
    'green',
    'greenyellow',
    'honeydew',
    'hotpink',
    'indianred',
    'indigo',
    'ivory',
    'khaki',
    'lavender',
    'lavenderblush',
    'lawngreen',
    'lemonchiffon',
    'lightblue',
    'lightcoral',
    'lightcyan',
    'lightgoldenrodyellow',
    'lightgray',
    'lightgrey',
    'lightgreen',
    'lightpink',
    'lightsalmon',
    'lightseagreen',
    'lightskyblue',
    'lightslategray',
    'lightslategrey',
    'lightsteelblue',
    'lightyellow',
    'lime',
    'limegreen',
    'linen',
    'magenta',
    'maroon',
    'mediumaquamarine',
    'mediumblue',
    'mediumorchid',
    'mediumpurple',
    'mediumseagreen',
    'mediumslateblue',
    'mediumspringgreen',
    'mediumturquoise',
    'mediumvioletred',
    'midnightblue',
    'mintcream',
    'mistyrose',
    'moccasin',
    'navajowhite',
    'navy',
    'oldlace',
    'olive',
    'olivedrab',
    'orange',
    'orangered',
    'orchid',
    'palegoldenrod',
    'palegreen',
    'paleturquoise',
    'palevioletred',
    'papayawhip',
    'peachpuff',
    'peru',
    'pink',
    'plum',
    'powderblue',
    'purple',
    'red',
    'rosybrown',
    'royalblue',
    'saddlebrown',
    'salmon',
    'sandybrown',
    'seagreen',
    'seashell',
    'sienna',
    'silver',
    'skyblue',
    'slateblue',
    'slategray',
    'slategrey',
    'snow',
    'springgreen',
    'steelblue',
    'tan',
    'teal',
    'thistle',
    'tomato',
    'turquoise',
    'violet',
    'wheat',
    'white',
    'whitesmoke',
    'yellow',
    'yellowgreen'
];
// TODO test if template literals can be used in a project with a large design config without destroying the performance
var INTEGER = "\\d{1,3}";
var PERCENTAGE_NUMBER = "(\\d{1}(\\.\\d+)?|\\.\\d+)";
var PERCENTAGE = "(\\d{1,3}(\\.\\d+)?|\\.\\d+)\\%";
var COLOR_HEX = type_guard_1.pattern("#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})");
var COLOR_HSL = type_guard_1.pattern("hsl\\(" + INTEGER + ",\\s*" + PERCENTAGE + ",\\s*" + PERCENTAGE + "\\)");
var COLOR_HSLA = type_guard_1.pattern("hsla\\(" + INTEGER + ",\\s*" + PERCENTAGE + ",\\s*" + PERCENTAGE + ",\\s*" + PERCENTAGE_NUMBER + "\\)");
var COLOR_NAME = type_guard_1.enums(COLOR_NAMES);
var COLOR_RGB = type_guard_1.pattern("rgb\\(" + INTEGER + ",\\s*" + INTEGER + ",\\s*" + INTEGER + "\\)");
var COLOR_RGBA = type_guard_1.pattern("rgba\\(" + INTEGER + ",\\s*" + INTEGER + ",\\s*" + INTEGER + ",\\s*" + PERCENTAGE_NUMBER + "\\)");
exports.color = {
    any: type_guard_1.union([COLOR_NAME, COLOR_HEX, COLOR_RGB, COLOR_RGBA, COLOR_HSL, COLOR_HSLA]),
    name: COLOR_NAME,
    hex: COLOR_HEX,
    hsl: COLOR_HSL,
    hsla: COLOR_HSLA,
    rgb: COLOR_RGB,
    rgba: COLOR_RGBA
};
